export const colorsData = [
  {
    color: "Slate",
    colors: [
      [0, "#f8fafc"],
      [1, "#f1f5f9"],
      [2, "#e2e8f0"],
      [3, "#cbd5e1"],
      [4, "#94a3b8"],
      [5, "#64748b"],
      [6, "#475569"],
      [7, "#334155"],
      [8, "#1e293b"],
      [9, "#0f172a"]
    ]
  },
  {
    color: "Gray",
    colors: [
      [0, "#f9fafb"],
      [1, "#f3f4f6"],
      [2, "#e5e7eb"],
      [3, "#d1d5db"],
      [4, "#9ca3af"],
      [5, "#6b7280"],
      [6, "#4b5563"],
      [7, "#374151"],
      [8, "#1f2937"],
      [9, "#111827"]
    ]
  },
  {
    color: "Zinc",
    colors: [
      [0, "#fafafa"],
      [1, "#f4f4f5"],
      [2, "#e4e4e7"],
      [3, "#d4d4d8"],
      [4, "#a1a1aa"],
      [5, "#71717a"],
      [6, "#52525b"],
      [7, "#3f3f46"],
      [8, "#27272a"],
      [9, "#18181b"]
    ]
  },
  {
    color: "Neutral",
    colors: [
      [0, "#fafafa"],
      [1, "#f5f5f5"],
      [2, "#e5e5e5"],
      [3, "#d4d4d4"],
      [4, "#a3a3a3"],
      [5, "#737373"],
      [6, "#525252"],
      [7, "#404040"],
      [8, "#262626"],
      [9, "#171717"]
    ]
  },
  {
    color: "Stone",
    colors: [
      [0, "#fafaf9"],
      [1, "#f5f5f4"],
      [2, "#e7e5e4"],
      [3, "#d6d3d1"],
      [4, "#a8a29e"],
      [5, "#78716c"],
      [6, "#57534e"],
      [7, "#44403c"],
      [8, "#292524"],
      [9, "#1c1917"]
    ]
  },
  {
    color: "Red",
    colors: [
      [0, "#fef2f2"],
      [1, "#fee2e2"],
      [2, "#fecaca"],
      [3, "#fca5a5"],
      [4, "#f87171"],
      [5, "#ef4444"],
      [6, "#dc2626"],
      [7, "#b91c1c"],
      [8, "#991b1b"],
      [9, "#7f1d1d"]
    ]
  },
  {
    color: "Orange",
    colors: [
      [0, "#fff7ed"],
      [1, "#ffedd5"],
      [2, "#fed7aa"],
      [3, "#fdba74"],
      [4, "#fb923c"],
      [5, "#f97316"],
      [6, "#ea580c"],
      [7, "#c2410c"],
      [8, "#9a3412"],
      [9, "#7c2d12"]
    ]
  },
  {
    color: "Amber",
    colors: [
      [0, "#fffbeb"],
      [1, "#fef3c7"],
      [2, "#fde68a"],
      [3, "#fcd34d"],
      [4, "#fbbf24"],
      [5, "#f59e0b"],
      [6, "#d97706"],
      [7, "#b45309"],
      [8, "#92400e"],
      [9, "#78350f"]
    ]
  },
  {
    color: "Yellow",
    colors: [
      [0, "#fefce8"],
      [1, "#fef9c3"],
      [2, "#fef08a"],
      [3, "#fde047"],
      [4, "#facc15"],
      [5, "#eab308"],
      [6, "#ca8a04"],
      [7, "#a16207"],
      [8, "#854d0e"],
      [9, "#713f12"]
    ]
  },
  {
    color: "Lime",
    colors: [
      [0, "#f7fee7"],
      [1, "#ecfccb"],
      [2, "#d9f99d"],
      [3, "#bef264"],
      [4, "#a3e635"],
      [5, "#84cc16"],
      [6, "#65a30d"],
      [7, "#4d7c0f"],
      [8, "#3f6212"],
      [9, "#365314"]
    ]
  },
  {
    color: "Green",
    colors: [
      [0, "#f0fdf4"],
      [1, "#dcfce7"],
      [2, "#bbf7d0"],
      [3, "#86efac"],
      [4, "#4ade80"],
      [5, "#22c55e"],
      [6, "#16a34a"],
      [7, "#15803d"],
      [8, "#166534"],
      [9, "#14532d"]
    ]
  },
  {
    color: "Emerald",
    colors: [
      [0, "#ecfdf5"],
      [1, "#d1fae5"],
      [2, "#a7f3d0"],
      [3, "#6ee7b7"],
      [4, "#34d399"],
      [5, "#10b981"],
      [6, "#059669"],
      [7, "#047857"],
      [8, "#065f46"],
      [9, "#064e3b"]
    ]
  },
  {
    color: "Teal",
    colors: [
      [0, "#f0fdfa"],
      [1, "#ccfbf1"],
      [2, "#99f6e4"],
      [3, "#5eead4"],
      [4, "#2dd4bf"],
      [5, "#14b8a6"],
      [6, "#0d9488"],
      [7, "#0f766e"],
      [8, "#115e59"],
      [9, "#134e4a"]
    ]
  },
  {
    color: "Cyan",
    colors: [
      [0, "#ecfeff"],
      [1, "#cffafe"],
      [2, "#a5f3fc"],
      [3, "#67e8f9"],
      [4, "#22d3ee"],
      [5, "#06b6d4"],
      [6, "#0891b2"],
      [7, "#0e7490"],
      [8, "#155e75"],
      [9, "#164e63"]
    ]
  },
  {
    color: "Sky",
    colors: [
      [0, "#f0f9ff"],
      [1, "#e0f2fe"],
      [2, "#bae6fd"],
      [3, "#7dd3fc"],
      [4, "#38bdf8"],
      [5, "#0ea5e9"],
      [6, "#0284c7"],
      [7, "#0369a1"],
      [8, "#075985"],
      [9, "#0c4a6e"]
    ]
  },
  {
    color: "Blue",
    colors: [
      [0, "#eff6ff"],
      [1, "#dbeafe"],
      [2, "#bfdbfe"],
      [3, "#93c5fd"],
      [4, "#60a5fa"],
      [5, "#3b82f6"],
      [6, "#2563eb"],
      [7, "#1d4ed8"],
      [8, "#1e40af"],
      [9, "#1e3a8a"]
    ]
  },
  {
    color: "Indigo",
    colors: [
      [0, "#eef2ff"],
      [1, "#e0e7ff"],
      [2, "#c7d2fe"],
      [3, "#a5b4fc"],
      [4, "#818cf8"],
      [5, "#6366f1"],
      [6, "#4f46e5"],
      [7, "#4338ca"],
      [8, "#3730a3"],
      [9, "#312e81"]
    ]
  },
  {
    color: "Violet",
    colors: [
      [0, "#f5f3ff"],
      [1, "#ede9fe"],
      [2, "#ddd6fe"],
      [3, "#c4b5fd"],
      [4, "#a78bfa"],
      [5, "#8b5cf6"],
      [6, "#7c3aed"],
      [7, "#6d28d9"],
      [8, "#5b21b6"],
      [9, "#4c1d95"]
    ]
  },
  {
    color: "Purple",
    colors: [
      [0, "#faf5ff"],
      [1, "#f3e8ff"],
      [2, "#e9d5ff"],
      [3, "#d8b4fe"],
      [4, "#c084fc"],
      [5, "#a855f7"],
      [6, "#9333ea"],
      [7, "#7e22ce"],
      [8, "#6b21a8"],
      [9, "#581c87"],
    ]
  },
  {
    color: "Fuchsia",
    colors: [
      [0, "#fdf4ff"],
      [1, "#fae8ff"],
      [2, "#f5d0fe"],
      [3, "#f0abfc"],
      [4, "#e879f9"],
      [5, "#d946ef"],
      [6, "#c026d3"],
      [7, "#a21caf"],
      [8, "#86198f"],
      [9, "#701a75"]
    ]
  },
  {
    color: "Pink",
    colors: [
      [0, "#fdf2f8"],
      [1, "#fce7f3"],
      [2, "#fbcfe8"],
      [3, "#f9a8d4"],
      [4, "#f472b6"],
      [5, "#ec4899"],
      [6, "#db2777"],
      [7, "#be185d"],
      [8, "#9d174d"],
      [9, "#831843"]
    ]
  },
  {
    color: "Rose",
    colors: [
      [0, "#fff1f2"],
      [1, "#ffe4e6"],
      [2, "#fecdd3"],
      [3, "#fda4af"],
      [4, "#fb7185"],
      [5, "#f43f5e"],
      [6, "#f43f5e"],
      [7, "#be123c"],
      [8, "#9f1239"],
      [9, "#881337"]
    ]
  }
];

export const fontsData = [
  "Montserrat",
  "Poppins"
];